export default __webpack_public_path__ + "static/media/logo.a5b6ed67.jpg";